/* Component Dependencies */
var hotelCategoryTierChartTemplate = require('templates/hotelCategoryTierChart.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
AriesComponent.create({
  type: 'hotelCategoryTierChart',
  template: {
    'hotelCategoryTierChart': hotelCategoryTierChartTemplate,
  },
  bindEvents: function() {
    var _self = this;
    this.$el.find('.ui-tabs-nav > li').on('click', function(e) {
      _self.toggleTabs.call(this, _self, e);
    })
  },
  /**
   * This function is used to show or hide hotelCategoryTierChart Template based on selected tab
   * @param {element, event} event Event object is passed
   */
  toggleTabs: function(elm, e) {
			e.preventDefault();
    var toggleElm = this,
      tabName = $(toggleElm).data('tabName');
      elm.$el.find('.ui-tabs-nav > li').removeClass('ui-tabs-selected t-bg-standard-20').addClass('t-bg-standard-30  t-border-standard-110').end()
      .find('.t-tab-content > div').removeClass('active').end()
      .find('#' + tabName).addClass('active');

    $(toggleElm).addClass('ui-tabs-selected t-bg-standard-20').removeClass('t-bg-standard-30  t-border-standard-110');
  }
});
